import '../../css/style.scss';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {render} from 'preact';
import $ from '@modules/jquery-import';
import {tippy, TooltipPlugins} from '@ultradent/components';
import abTests from '@upi/abTests';
import Modal from '@plugins/modal';
import {intlNewsletterDialog} from '@util/HtmlComponents';
import dataLayer from './data-layer';
import appLogger from '@core/LoggingProvider';
import assign from 'object-assign';
import namespace from './namespace';
import View from '@core/View';
import User from '@modules/User';
import CountdownTimer from '@modules//ui/CountdownTimer';
import * as Media from '@util/MediaUtils';
import isSiteFeatureEnabled from '@util/fn/isSiteFeatureEnabled';
import {COOKIES, getCookie, setCookie} from '@util/StorageUtils';
import Cookies from 'js-cookie';
import {$SITE_MESSAGE_BAR} from '@config/selectors';
import CartQuickView from '@modules/cart/CartQuickView';
import SearchSuggestions from '../search-suggestions';
import DentalProDialog from '../components/dialogs/DentalProDialog';
import Header from '@modules/ui/header';
import Footer from '@modules/ui/Footer';
import EliteStatus from '@modules/account/eliteStatus';
import mediaQuery from '@util/media-queries';
import {USER_NOTIF_STORE} from '@upi/constants';
import {fetchCORSResource} from '@ultradent/utilities/Media';
import {
    jqueryAccordion,
    jqueryCustomFields,
    jqueryIsolatedScroll,
    jqueryScrolling,
    jqueryTabs,
    jqueryToggleQtySelect,
    jqueryTooltip,
    photoGallery
} from '@modules/lazy-imports';
import {isEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';
import {trackProductLists} from './dom-product-list-analytics';
import {synchronizeCommerceAttributionScope} from './commerce-attribution-store';

if ( process.env.NODE_ENV === 'development' ) {
    require( 'preact/debug' );
}

synchronizeCommerceAttributionScope( undefined, undefined, undefined, {
    preserveCartAttribution: window.location.pathname === '/checkout/confirmation'
} );

// configure exception logger to user context
const loggingUserId = User.getInfo().uid;
if ( loggingUserId != null && loggingUserId !== '' ) {
    appLogger.configure( {
        user: {id: loggingUserId}
    } );
}

// Initialize Common page elements
assign( namespace( 'Site' ), {
    _initializers: {},

    // prepend initializer to a specified namespaced component initalizer
    // useful when needing to initalize nested components such as a tabset within an accordion
    // that needs to set panel height
    addInitializer ( namespace, fn ) {
        if ( typeof namespace === 'function' ) {
            fn = namespace;
            namespace = 'default';
        }

        this._initializers[namespace] = this._initializers[namespace] || [];
        this._initializers[namespace].push( fn );
    },

    callInitializers ( namespace ) {
        namespace = namespace || 'default';

        var initializers = this._initializers[namespace];

        if ( initializers && initializers.length ) {
            $.each( initializers, function ( i, fn ) {
                fn.call( this );
            }.bind( this ) );
        }
    },

    onDOMLoad () {
        this.patches();

        this.serviceWorker.init();

        abTests.logActiveTests();

        Header.init();
        this.messageBar.init();
        this.forms();
        this.searchBar.init();
        this.media.init();
        this.commonUI.init();
        this.account.init();
        this.tracking.init();
        Footer.init();

        if ( upi.conf.isEcommerceSite && navigator.cookieEnabled ) {
            this.cart.init();
        }
    },

    onWindowLoad () {
        console.log( '[Page initalized]' );

        this.a11y.init();
    },

    serviceWorker: {
        init () {
            if ( !navigator.serviceWorker ) {
                return;
            }

            if ( process.env.NODE_ENV === 'production' ) {
                // wait until page has loaded before init service worker ot improve performance
                window.addEventListener( 'load', function () {
                    navigator.serviceWorker.register( '/service-worker.js' )
                        .then( reg => {
                            const {
                                waiting,
                                installing
                            } = reg;
                            console.log( '[serviceWorker status]',
                                {
                                    waiting,
                                    installing
                                } );
                        } )
                        .catch( err => console.warn( '[serviceWorker initialization failed]', err ) );
                } );
            }
        }
    },

    account: {

        nodes: {},

        init () {
            EliteStatus.init();

            // initialize newsletter form for EU only
            $( '#newsletterForm-eu .button' ).on( 'click', ( e ) => {
                const modal = Modal.getInstance();
                const target = e.currentTarget;
                modal.open( {
                    content: intlNewsletterDialog( {
                        modal,
                        formId: target.dataset['hubspotFormid'],
                        portalId: target.dataset['hubspotPortalid']
                    } ),
                    width: 560
                } );
            } );
            this.nodes.userNotificationLines = document.querySelectorAll( `[data-user-notification]` );
            this.nodes.notifCount = document.querySelectorAll( `[data-notif-count]` );

            if ( this.nodes.notifCount?.length > 1 ) {
                this.profileNotifications();
            }

            $( window ).on( 'notificationsUpdated', ( e, data ) => {
                this.profileNotifications();
            } )
        },

        profileNotifications () {
            let notifStore = this.notifStoreCheck();

            let notifNumber = this.notifCheck( notifStore );

            let dotClass = document.querySelectorAll( '.accountNotificationDot' );
            [...dotClass].forEach( el => el.setAttribute( 'data-notif-count', notifNumber ) );

            [...this.nodes.notifCount].forEach( el => {
                if ( notifNumber <= 0 ) {
                    el.classList.remove( 'notification--active' );
                }
            } );
        },

        notifStoreCheck () {
            try {
                return JSON.parse( this.getNotificationStore() )
            }
            catch ( err ) {
                return [];
            }
        },

        notifCheck ( notifStore ) {
            let notifList = this.getNotificationList();
            if ( notifStore == null ) {
                return notifList.length;
            }

            return (notifList.length) - (notifStore.length);
        },

        getNotificationList () {
            return User.getNotifications().map( i => String( i ) );
        },

        getNotificationStore () {
            return localStorage.getItem( USER_NOTIF_STORE );
        }
    },

    a11y: {
        init () {
            // Make Osano elements WCAG conformant by adding aria attributes and roles
            const osanoWindow = document.querySelector( '.osano-cm-window' );
            console.log( 'osanoWindow', osanoWindow )
            // change svg[role="img"] to role="presentation" for screen readers to read content
            if ( osanoWindow ) {
                osanoWindow.querySelectorAll( 'svg[role="img"]' )
                    .forEach( el => el.setAttribute( 'role', 'presentation' ) );
            }
        }
    },

    cart: {
        async init () {
            // globally handle item views and cart addition confirmations
            new CartQuickView( 'body' );

            const MiniCart = await import(/*webpackChunkName: "~~upi-minicart"*/ '../mini-cart' );
            if ( MiniCart && MiniCart.default ) {
                MiniCart.default.init( isSiteFeatureEnabled( 'MiniCart' ) );
            }
        }
    },

    patches () {
        // patch: windows safari incomplete cssanimation support
        if ( /windows.*safari/i.test( navigator.userAgent ) ) {
            $( 'html' ).toggleClass( 'cssanimations', 'no-cssanimations' );
        }
    },

    searchBar: {
        init () {
            const searchContainer = document.getElementById( 'search-bar-wrapper--header' );

            if ( searchContainer ) {
                SearchSuggestions.init();
            }
        }
    },

    messageBar: {
        init () {
            const self = this;
            const msgs = document.querySelectorAll( $SITE_MESSAGE_BAR );
            Array.from( msgs ).forEach( node => {
                const cookieName = node.dataset.msgName || 'site-msg';
                const hideNumDays = node.dataset.hideNumDays || 1;
                const isPersistent = node.classList.contains( 'notice' ) || !!hideNumDays;
                // cookieData = COOKIES.SITE_NOTICE_BAR; // defaults to upi_notice
                if ( self.isActive( node, cookieName, isPersistent ) ) {
                    self.show( node );
                    const closeBtn = node.querySelector( '[data-action="close"]' );
                    closeBtn.addEventListener( 'click', () => {
                        if ( isPersistent ) {
                            setCookie( {
                                // namespace message bar cookies
                                cookie: COOKIES.SITE_NOTICE_BAR,
                                key: {name: cookieName},
                                value: 'disabled'
                            }, {expires: 60 * 24 * hideNumDays} ); // disable for specified days OR 24 hours
                        }

                        self.hide( node );
                    } );
                }
            } );
        },
        show ( el ) {
            el.classList.remove( 'hidden' );
        },
        hide ( el ) {
            el.classList.add( 'hidden' );
        },
        isActive ( el, name, isPersistent ) {
            // check that the messageBar is on DOM and and a cookie has not been set for message (which means it's been read and closed)
            if ( isPersistent ) {
                var msgPattern = new RegExp( name + '~disabled', 'g' ),
                    upiNoticeCookie = getCookie( COOKIES.SITE_NOTICE_BAR );

                return (typeof el !== 'undefined' && !msgPattern.test( upiNoticeCookie ));
            }

            return true;
        }
    },

    forms () {
        // initialize input masks through data-inputmask attr
        // usage: https://github.com/RobinHerbots/Inputmask#via-data-inputmask-attribute
        const maskableInputs = $( ':input[data-inputmask]' );
        upi.forms.inputmask.mask( maskableInputs );

        var $form = $( '#aspnetForm' ), $visibleFields;

        if ( $form[0] ) {
            $visibleFields = $( $form[0].elements ).filter( function ( el ) {
                return 'hidden' != el.type;
            } );

            // bind auto-clear
            $visibleFields.filter( '[data-autoclear]' ).on( 'blur', function () {
                this.value = '';
            } );
        }

        // note - exclude these forms from Hubspot tracking
        const formIds = ['usLogin',
            'loginForm1',
            'passwordResetForm',
            'accountLookupForm',
            'newCustomerRegistrationForm'];

        // note - add data-hs-ignore attribute to forms that should not be tracked by Hubspot
        document.querySelectorAll( 'form' ).forEach( form => {
            if ( formIds.includes( form.id ) ) {
                form.dataset.hsIgnore = true;
            }
        } );
    },

    media: {
        init () {

            const handleImage404 = function ( e ) {
                const el = e.target;
                if ( el.nodeName.toLowerCase() === 'img' ) {
                    el.classList.add( 'img-broken' );
                }
            };
            // bind to event capture phase since 'error' events do not bubble
            document.body.addEventListener( 'error', handleImage404, true );

            $( '#body-content' ).on( 'click', 'a[href*="//www.youtube.com/embed"]', function ( e ) {
                const target = e.currentTarget;

                e.preventDefault();
                if ( window.matchMedia( mediaQuery.max['screenMedium'] ).matches ) {
                    // embed video to target
                    Media.embedMediaToTarget.call( target, true );
                }
                else {
                    Modal.getInstance().open( {
                        width: '75%',
                        content: Media.getMediaEmbedFor( target.href, true )
                    } );
                }
            } );
        }
    },

    commonUI: {
        init () {
            var bodyContentEl = document.getElementById( 'body-content' );

            // initialize general modals
            Modal.getInstance();

            upi.Site.callInitializers( 'commonUI' );

            if ( !navigator.cookieEnabled ) {
                $( 'html' ).addClass( 'no-cookies' );

                $( '#loginForm1' ).replaceWith( `
                    <a href="/login" class="button w-full my-4">
                        <svg class="svgi-lock-closed text-xl mr-2">
                            <use xlink:href="/svg/ui-defs.svg#icon-lock-closed"></use>
                        </svg>
                        Sign in
                    </a>
                ` );
            }

            if ( !upi.env.IS_ENUS ) {
                $( 'html' ).addClass( 'international' );
            }

            if ( window.parent !== window ) {
                $( 'html' ).addClass( 'is-iframe' );
            }

            if ( upi.conf.isDentalProRequired && !Cookies.get( 'UpiDentalProfessional' ) && bodyContentEl ) {
                render( <DentalProDialog/>, bodyContentEl );
            }

            // note - add resize listener to sync window height property for scroll locking class '.is-locked'
            window.addEventListener( 'resize', function syncHeight () {
                document.documentElement.style.setProperty( '--window-inner-height', `${window.innerHeight}px` );
            } );

            // declarative hook for disabling touch events on links
            $( document )
                .on( 'click', 'a[data-prevent-touch-nav]', e => window.USER_IS_TOUCHING && e.preventDefault() );

            $( document )
                .on( 'click', 'a[data-download]', e => {
                    e.preventDefault();
                    fetchCORSResource( e.currentTarget.href, e.currentTarget.dataset?.download );
                } );

            // initialize print buttons
            $( document ).on( 'click', '.button.print', function ( e ) {
                e.preventDefault();
                window.print();
            } );

            // Determine if the user is actually using their touch screen
            $( 'html' ).addClass( 'no-screentouches' );

            // detect if user is using touch interface on touch/hybrid device
            $( window ).on( 'touchstart', function onFirstTouch () {
                window.USER_IS_TOUCHING = true;
                $( 'html' ).removeClass( 'no-screentouches' ).addClass( 'screentouches' );
                $( window ).off( 'touchstart', onFirstTouch );
            } );

            // simple collapsing content -> uses .collapse-group component
            $( document ).on( 'click', '[data-collapse-trigger]', e => {
                const el = e.currentTarget;

                if ( el.dataset.disabled ) {
                    return false;
                }

                // e.preventDefault();
                const group = $( el ).parents( '.collapse-group' );
                group.toggleClass( 'collapse-group--active' );

                const labelToggle = group.find( '[data-collapse-toggle-label]' );
                if ( labelToggle.length ) {
                    const data = labelToggle[0].dataset;
                    const labelValue = group.hasClass( 'collapse-group--active' )
                        ? data.labelActive
                        : data.labelInactive;

                    if ( labelValue ) {
                        labelToggle.text( labelValue );
                    }
                }
            } );

            // note -> setup clipboard items
            $( document ).on( 'click', '[data-clipboard-text]', function ( e ) {
                const el = e.currentTarget;
                const text = el.dataset.clipboardText;
                navigator.clipboard.writeText( text )
                    .then( () => upi.Notifier.notify( `${text} copied!` ),
                        () => upi.Notifier.error( `Failed to copy text.` ) );
            } );

            // restrict form input (with class"digits") to digits only
            $( document ).on( 'keypress', '[contenteditable], input, textarea', upi.forms.restrict_input_values );

            // trim all input values
            $( document ).on( 'change', 'input, textarea', upi.forms.handleTrimInput );

            // popovers
            const getPopoverTemplate = ref => {
                const id = ref.getAttribute( 'data-tip-template' );
                const template = document.getElementById( id );
                return template.innerHTML;
            };
            tippy( '[data-tip-popover]', {
                content: getPopoverTemplate,
                allowHTML: true,
                arrow: false,
                interactive: true,
                theme: 'light',
                touch: true,
                placement: 'bottom'
            } );

            tippy( '[data-tip-popover-click]', {
                plugins: [TooltipPlugins.hideOnEsc],
                content: getPopoverTemplate,
                trigger: 'click',
                allowHTML: true,
                arrow: false,
                interactive: true,
                theme: 'light',
                placement: 'bottom-end',
                touch: true
            } );

            const logPluginWarning = this.logPluginWarning;

            this.loadPluginIfNodeExists( photoGallery, '[data-photo-gallery]' )
                .catch( logPluginWarning );

            this.loadPluginIfNodeExists( jqueryScrolling, 'body' )
                .then( () => {
                    // bind auto-scrollers
                    $( document ).on( 'click', 'a[data-auto-scroll]', function ( e ) {
                        e.preventDefault();
                        var $target = $( '#' + this.href.split( '#' )[1] );
                        // only attach to <a href="#target">
                        if ( !this.href || !$target[0] ) {
                            return;
                        }
                        $( $target ).scrollToElement();
                    } );
                } )
                .catch( logPluginWarning );

            this.loadPluginIfNodeExists( jqueryTabs, '.tabset' )
                .then( nodes => nodes.tabs() )
                .catch( logPluginWarning );

            this.loadPluginIfNodeExists( jqueryAccordion, '.accordion' )
                .then( nodes => {
                    nodes
                        .filter( function () {
                            return this.parentNode.nodeName.toLowerCase() !== 'code';
                        } )
                        .accordion( {single_view: true} );
                } )
                .catch( logPluginWarning );

            // general tooltips
            this.loadPluginIfNodeExists( jqueryTooltip, document )
                .then( nodes => nodes.tooltip() )
                .catch( logPluginWarning );

            this.loadPluginIfNodeExists( jqueryIsolatedScroll, '.navmenu' )
                .then( nodes => nodes.isolatedScroll() )
                .catch( logPluginWarning );

            // convert SKU qty selector to 1-10+ dropdown that converts to an input when 10+ is selected
            this.loadPluginIfNodeExists( jqueryToggleQtySelect, 'input[data-qty-select-toggle]' )
                .then( nodes => nodes.toggleQtySelect() )
                .catch( logPluginWarning );

            // convert fields to custom that fall within the main content wrapepr and hidden light boxes
            jqueryCustomFields().then( () => {
                $( '#body-content, .inline-lightbox' )
                    .find( 'input[type="file"], :radio, :checkbox' )
                    .toCustomFields();
            } );

            if ( !$( '#payYourBill' ).length ) {
                let payYourBillView = new View( 'payYourBill' );
                setTimeout( function () {
                    $( 'body' ).append( payYourBillView.render( {} ) );
                }, 600 );
            }

            // insert backorder policy dialog if not already on page
            if ( !$( '#backorderPolicy' ).length ) {
                let backorderView = new View( 'backorderPolicy' );
                setTimeout( function () {
                    $( 'body' ).append( backorderView.render( {} ) );
                }, 500 );
            }

            // initialize countdown timers
            document.querySelectorAll( '[data-countdown-target]' ).forEach( el => {
                const targetDate = new Date( el.dataset.countdownTarget );
                if ( targetDate.toString() === 'Invalid Date' ) {
                    console.error( `Invalid countdown target date: ${el.dataset.countdownTarget}` );
                    return;
                }
                const offsetHours = parseFloat( el.dataset.countdownTimezoneOffset ) || 0;
                const timer = new CountdownTimer( el, targetDate, offsetHours );
                timer.start();
            } );
        },
        loadPluginIfNodeExists: ( pluginPromise, selector ) => {
            const node = $( selector );
            if ( node.length > 0 ) {
                return pluginPromise().then( () => node );
            }

            return Promise.reject( `[Deferred plugin] "${pluginPromise.name}" because '${selector}' not found` );
        },
        logPluginWarning: err => console.warn( err )
    },

    tracking: {
        init () {
            this.applyProductClickTracking();
            trackProductLists();
            this.applyPromoClickTracking();
            this.applyPromoViewTracking();
            this.applyHubspotFormTracking();

            this.pageViews();
        },

        applyProductClickTracking () {
            document.addEventListener( 'click', ( e ) => {
                let {target} = e;
                const check = () => target?.dataset?.hasOwnProperty( 'trackProduct' );

                while ( target && !check() ) {
                    target = target.parentNode;
                }
                if ( check() ) {
                    this.handleProductClick( e, target );
                }
            } )
        },

        applyPromoClickTracking () {
            document.addEventListener( 'click', ( e ) => {
                let {target} = e;
                const check = () => target?.dataset?.hasOwnProperty( 'promoId' );

                while ( target && !check() ) {
                    target = target.parentNode;
                }
                if ( check() ) {
                    this.handlePromoClick( target );
                }
            } )
        },

        applyPromoViewTracking ( nodeList ) {
            let promoItems = nodeList || document.querySelectorAll( '[data-promo-id]' );
            if ( isEmptyOrNil( promoItems ) ) {
                return;
            }

            // track when promotions are in viewport for elements with [data-promo-id]
            const promoObserver = new IntersectionObserver( entries => {
                for ( let i = 0; i < entries.length; i++ ) {
                    if ( entries[i].isIntersecting ) {
                        const el = entries[i].target;
                        this.handlePromoView( el );
                        promoObserver.unobserve( el );
                    }
                }
            }, {threshold: [0.5]} );

            // coerce Node/NodeList into an array
            if ( promoItems instanceof NodeList ) {
                promoItems = Array.from( promoItems );
            }
            if ( !Array.isArray( promoItems ) ) {
                promoItems = [promoItems];
            }

            const promoMap = new Map();

            // filter out duplicate promo items by creativeName
            promoItems.forEach( promo => {
                const id = promo.dataset.promoName + ' ' + promo.dataset.promoCreativeName;
                if ( promoMap.has( id ) ) {
                    return false;
                }
                promoMap.set( id, promo );
            } );

            promoMap.forEach( promo => promoObserver.observe( promo ) );
        },

        applyHubspotFormTracking () {
            window.addEventListener( 'message', event => {
                if ( event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted' ) {
                    console.log( '[Hubspot Form submitted]', event.data );
                    const formDetail = this.getFormDetail( event.data.id );
                    const data = {
                        event: 'ajax_form_submit',
                        form_name: formDetail.name,
                        form_destination: formDetail.action
                    };

                    console.log( '[GA4 dataLayer]', data );
                    dataLayer.push( data );
                }
            } );
        },

        getFormDetail ( id ) {
            const form = document.querySelector( `form[data-form-id="${id}"]` );

            if ( !form ) {
                return {
                    name: id || 'Unknown',
                    action: window.location.pathname
                };
            }

            return {
                name: form.name || form.dataset.formName || id,
                action: form.action || window.location.pathname
            };
        },

        getItemData ( el ) {
            if ( !el ) {
                console.error( `expected "el" to be HTMLElement and received ${el} instead` );
            }
            return el.dataset || {};
        },

        handleProductClick ( e, target ) {
            const itemData = this.getItemData( target );
            dataLayer.product.sendProductClick( itemData );
        },

        handlePromoClick ( el ) {
            const promoData = this.getItemData( el );
            dataLayer.promotions.sendPromoClick( promoData );
        },

        handlePromoView ( el ) {
            const promoData = this.getItemData( el );
            dataLayer.promotions.sendPromoView( promoData );
        },

        pageViews () {
            window.addEventListener( 'load', async function () {
                switch ( window.location.pathname ) {
                    case '/':
                        return dataLayer.pageView.homepage();

                    case '/checkout':
                        await dataLayer.pageView.cart();
                        if ( User.getSalesChannel() === 'lgp' ) {
                            return dataLayer.checkout.beginCheckout();
                        }
                        return;

                    case '/checkout/payment':
                        dataLayer.checkout.beginCheckout();
                        return;

                    case '/checkout/confirmation':
                        const orderContainer = document.getElementById( 'ReviewItemContainer' );
                        if ( orderContainer ) {
                            return dataLayer.checkout.purchaseComplete( orderContainer.dataset.orderNumber );
                        }
                }
            } );
        }
    }
} );

upi.Site.onDOMLoad();

$( window ).on( 'load', function () {
    upi.Site.onWindowLoad();
    window.scrollBy && window.scrollBy( 1, 0 );
} );
